import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Expertise } from 'src/app/shared/models/expertise';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ExpertiseModalAjoutComponent } from '../modal/expertise-modal-ajout/expertise-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { ExpertiseModalDetailComponent } from '../modal/expertise-modal-detail/expertise-modal-detail.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-expertise',
	templateUrl: './list-expertise.component.html',
	styleUrls: ['./list-expertise.component.scss']
})
export class ListExpertiseComponent implements OnInit {
	expertise: Expertise[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	expertiseCsvFile: File = null;
	searchedSkill = '';
	searchedName = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editExpertiseModalRef: BsModalRef;
	addExpertiseModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getExpertise();
		this.isAddable = true;
	}

	getExpertise(): void {
		this.isListingLoading = true;
		this.facade.expertiseService.getAllExpertises().subscribe({
			next: (val) => {
				this.expertise = val.filter((e) => e.name !== 'Sans');
				this.itemsPerPage = this.expertise.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.expertise = [];
			}
		});
	}

	selectExpertise(expertise: Expertise): void {
		const link = ['/expertise', expertise.id];
		this.router.navigate(link);
	}

	importExpertise(event: any): void {
		this.expertiseCsvFile = event.target.files[0];

		this.facade.expertiseService
			.importExpertise(this.expertiseCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.alerts.push({
						type: 'success',
						msg: `${importStats.entitiesAdded} expertise ont été ajoutés,
                  ${importStats.entitiesBeforeImport} étaient déjà présents.`
					});

					this.getExpertise();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		this.addExpertiseModalRef = this.modalService.show(
			ExpertiseModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addExpertiseModalRef.onHide.subscribe((reason: string | any) => {
			this.getExpertise();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(expertise: Expertise) {
		const initialState = {
			expertise: expertise
		};
		this.editExpertiseModalRef = this.modalService.show(
			ExpertiseModalDetailComponent,
			{
				class: '',
				initialState
			}
		);

		this.editExpertiseModalRef.onHide.subscribe((reason: string | any) => {
			this.getExpertise();
		});
	}
}
